/*jshint esversion: 6 */

//temp:


function initPostponeArrays() {
  window.tempPresTimeMeans = [];
  window.tempPresTimeDeviations = [];
  window.tempISIMeans = [];
  window.tempISIDeviations = [];
  window.tempITIMeans = [];
  window.tempITIDeviations = [];
  window.tempPresTimeLast = [];
  window.tempISILast = [];
  window.tempITILast = [];
  window.tempPresTimeFrames = [];
  window.tempISIFrames = [];
}

initPostponeArrays();

(function () {
  'use strict';
  // keeps track of frames
  var framesCount = 0;
  // stores the delayed functions { f: function to execute, delay: frames, startFrame: framesCount }
  var waitingFunctions = [];
  var waitingCount = 1; // start at 1 so a clearPostpone for 0 would not clear other postponed function
  var prevTs;
  //var tsold = 0;

  function timerFrames(ts) {
    window.lastTs = ts;
    if(prevTs){
      const elapsed = ts - prevTs;
      window.listFrameTimes.push(elapsed);
      if(window.listFrameTimes.length == 10){
        const meanTimeBetweenFrames = window.meanFloats(window.listFrameTimes);
        const currentFramerate = 1000 / meanTimeBetweenFrames;
        const medianTimeBetweenFrames = window.median(window.listFrameTimes);
        //window.frameRate = meanTimeBetweenFrames;
        window.frameRate = medianTimeBetweenFrames;
        window.listFrameTimes = [];
        window.listFrameRates.push(currentFramerate);

        window.listFrameTimes.shift();
      }
    }

    framesCount += 1;

    //console.log('[debug_actual] ' + (ts - tsold));
    //tsold = ts;

    waitingFunctions.forEach(
      function (setup) {
        if (setup.startTime) {
          setup.listFrames.push((ts - prevTs).toFixed(2));
        }
        if (!setup.startTime) {
          setup.startTime = ts;
        }
        setup.remainingMs = setup.delayMs - (ts - setup.startTime);
      }
    );

    const executingFunctions = waitingFunctions.filter(
      function (setup) {
        return setup.remainingMs <= window.frameRate / 2;
      }
    );

    executingFunctions.forEach(
      function (setup) {
        setup.elapsedTime = ts - setup.startTime;
        const meanFrames = window.meanFloats(setup.listFrames).toFixed(2);
        const framesDelayedCount = framesCount - setup.startFrame;
        setup.decision = setup.remainingMs.toFixed(2) + 'ms_' + window.frameRate.toFixed(2);

        console.log('[debug_actual] rafTimer',/* setup.f,*/ setup, framesCount, framesDelayedCount);
        setup.f(
          {
            time: ts - setup.startTime,
            frames: framesDelayedCount,
            fps: meanFrames,
          }
        );

        //setup.lapsedTimeCallback && setup.lapsedTimeCallback.call(null, setup.elapsedTime, setup.startFramerate, meanFrames, sdFrames, setup.decision, framesDelayedCount);
      }
    );

    if (executingFunctions.length) {

      const iterator = Object.keys(waitingFunctions);
      for (var iKeys = 0; iKeys < iterator.length; iKeys++) {
        const key = iterator[iKeys];
        const setup = waitingFunctions[key];
        if (setup.remainingMs <= window.frameRate / 2) {
          delete waitingFunctions[key];
        }
      }
    }

    window.requestAnimationFrame(timerFrames);

    prevTs = ts;
  }

  function msToFrames(ms) {
    return Math.round(ms / window.frameRate || (1000/60));
  }

  function postponeTimingsForIndex(index) {
    const setup = waitingFunctions[index];
    if (!setup) {
      return null;
    }
    const ts = performance.now();
    const meanFrames = window.meanFloats(setup.listFrames).toFixed(2);
    const framesDelayedCount = framesCount - setup.startFrame;
    return {
      time: ts - setup.startTime,
      frames: framesDelayedCount,
      fps: meanFrames,
    };
  }

  // f - function to be executed before the last frame
  // delay - ms or frames
  // startTime - optional timestamp used as the start point of the timeout
  function postpone(f, delay, startTime) {
    if (f.constructor !== Function) {
      throw 'postpone needs first parameter to be a function';
    }

    if (!delay || delay == "na" || delay <= window.frameRate / 2) {
      console.log('rafTimer instant');
      f(
        {
          frames: 0,
          time: 0,
          fps: 0,
        }
      );
      return;
    }

    var delayFrames = delay;
    //if the time is not expressed in frames (precomputed), then convert to frames
    if(listTrialFrames[trialRow] == 0){
      delayFrames = msToFrames(delay);
    }

    const index = waitingCount;

    waitingFunctions[index] = {
      f: f,
      delayMs: delay,
      remainingMs: delay,
      delay: delayFrames,
      startFrame: framesCount + 1,
      startFramerate: Math.round(1000 / window.frameRate),
      listFrames: [],
      elapsedTime: 0,
    };

    if(startTime !== undefined){
      waitingFunctions[index].startTime = startTime;
      waitingFunctions[index].startFrame--;
    }

    console.log('[debug_actual] ' + JSON.stringify(waitingFunctions[index]));

    waitingCount += 1;

    return index;
  }

  function clearAllPostpones() {
    console.log('rafTimer clear ALL');
    waitingFunctions = [];
  }

  function clearPostpone(id) {
    console.log('rafTimer clear ' + id);
    delete waitingFunctions[id];
  }

  // start timer
  timerFrames();
  window.postpone = postpone;
  window.clearAllPostpones = clearAllPostpones;
  window.clearPostpone = clearPostpone;
  window.postponeTimingsForIndex = postponeTimingsForIndex;
}());